import ChampionCards from './champion-cards';
export default ChampionCards;